import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import HeroSlider from "@/pages/home/components/HeroSlider";
import QuickEntries from "@/pages/home/components/QuickEntries";
import HotRanking from "@/pages/home/components/HotRanking";
import AboutIntro from "@/pages/home/components/AboutIntro";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import { filterCatalog, getHeroList, getHotList, getLatestList } from "@/lib/catalog";

export default function Home() {
  useSeo({
    title: "金桔影院-最新电影电视剧推荐与在线观看平台",
    description:
      "金桔影院为您提供丰富的最新电影和电视剧资源，涵盖多种类型影视作品，方便用户在线浏览和了解影视资讯，打造全方位影视体验。",
    keywords: "金桔影院,电影推荐,电视剧更新,影视平台,在线观看电影,影视资讯,热门影视,院线大片",
    canonicalPath: "/",
  });

  const heroList = getHeroList();
  const latest = getLatestList(12);
  const hot = getHotList(6);
  const moviePicks = filterCatalog({ type: "movie", sort: "hot" }).slice(0, 6);
  const tvPicks = filterCatalog({ type: "tv", sort: "hot" }).slice(0, 6);

  return (
    <>
      <HeroSlider items={heroList} />
      <QuickEntries />

      <section className="mx-auto w-full max-w-8xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <SectionHeading
              icon="ri-time-line"
              title="最新影视推荐"
              subtitle="近期上线与更新的精选作品，第一时间了解内容看点"
              moreTo="/category/movie"
            />
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 xl:grid-cols-4">
              {latest.map((item) => (
                <MovieCard key={item.id} item={item} />
              ))}
            </div>
          </div>
          <div className="lg:sticky lg:top-24 lg:self-start">
            <HotRanking items={hot} />
          </div>
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-8xl px-4 py-12 md:px-6 md:py-14">
          <SectionHeading
            icon="ri-movie-line"
            title="热门电影精选"
            subtitle="口碑与热度兼具的院线佳作"
            moreTo="/category/movie"
          />
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 xl:grid-cols-6">
            {moviePicks.map((item, i) => (
              <MovieCard key={item.id} item={item} rank={i + 1} />
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-8xl px-4 py-12 md:px-6 md:py-14">
        <SectionHeading
          icon="ri-tv-2-line"
          title="热播剧集推荐"
          subtitle="正在追的高分剧集，一次看个够"
          moreTo="/category/tv"
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 xl:grid-cols-6">
          {tvPicks.map((item, i) => (
            <MovieCard key={item.id} item={item} rank={i + 1} />
          ))}
        </div>
        <div className="mt-8 flex justify-center">
          <Link
            to="/category/tv"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看更多剧集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <AboutIntro />
    </>
  );
}